import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const HeroSection = () => {
  const { t } = useTranslation('home');

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Subtle monochrome background */}
      <div
        className="absolute inset-0"
        style={{ background: "var(--gradient-hero)" }}
        aria-hidden="true"
      />

      {/* Soft frosted ambient orbs (very subtle) */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
        <div className="absolute top-1/4 left-1/4 w-[32rem] h-[32rem] bg-foreground/[0.03] rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-[32rem] h-[32rem] bg-foreground/[0.03] rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Eyebrow chip — Apple style */}
          <div className="inline-flex items-center gap-2 px-3 py-1 mb-8 rounded-full glass-panel text-xs font-medium text-muted-foreground">
            <span className="status-dot status-dot--ok" />
            <span>Nearshore.Africa · GDPR-compliant</span>
          </div>

          <h1 className="text-5xl md:text-7xl lg:text-[5.5rem] font-bold mb-6 text-foreground text-balance">
            {t('hero.title')}
          </h1>

          <p className="text-xl md:text-2xl text-foreground/80 mb-6 max-w-3xl mx-auto text-balance font-medium">
            {t('hero.subtitle')}
          </p>

          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto mb-12">
            {t('hero.description')}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button size="lg" asChild>
              <a href="https://www.evolvice.de/en" target="_blank" rel="noopener noreferrer">
                {t('hero.buttons.explore')}
                <ArrowRight size={18} />
              </a>
            </Button>
            <Button size="lg" variant="glass" asChild>
              <a href="https://www.evolvice.de/en" target="_blank" rel="noopener noreferrer">
                {t('hero.buttons.learn')}
              </a>
            </Button>
          </div>

          {/* Stats — Apple system-style */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-px mt-24 rounded-2xl overflow-hidden glass-panel">
            {[
              { value: "729k", label: t('hero.stats.developers') },
              { value: "60%", label: t('hero.stats.savings') },
              { value: "30%", label: t('hero.stats.efficiency') },
              { value: "48%", label: t('hero.stats.outsourcing') },
            ].map((stat, index) => (
              <div key={index} className="bg-background/40 px-6 py-8 text-center">
                <div className="text-3xl md:text-4xl font-bold text-foreground tracking-tight">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-muted-foreground mt-2 uppercase tracking-wider">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
